<template>
    <footer class="site-footer">
        <div class="container">
            <div class="footer-inner">
                <a href="#" class="footer-brand">
                    <img src="/images/logo.png" height="30" alt="LePegue" />
                </a>
                <div class="footer-social">
                    <a href="https://wa.me/50222927882" target="_blank">
                        <i class="fab fa-2x fa-whatsapp text-success"></i>
                    </a>
                    <a href="https://facebook.com/lepegue" target="_blank">
                        <i class="fab fa-2x fa-facebook text-facebook"></i>
                    </a>
                    <a
                        href="https://www.instagram.com/lepegueapp"
                        target="_blank"
                    >
                        <i class="fab fa-2x fa-instagram text-instagram"></i>
                    </a>
                </div>
            </div>
            <p class="footer-copy">
                &copy; {{ year }} Le Pegue. Todos los derechos reservados.
            </p>
        </div>
    </footer>
</template>

<script>
export default {
    name: "HomeBottom",
    computed: {
        year() {
            return new Date().getFullYear();
        },
    },
};
</script>

<style scoped>
.site-footer {
    background-color: #f8f9fa;
    border-top: 1px solid #e9ecef;
    padding: 24px 0 16px;
}

.footer-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
}

.footer-social {
    display: flex;
    align-items: center;
    gap: 16px;
}

.footer-social a {
    text-decoration: none;
    transition: opacity 0.2s;
}

.footer-social a:hover {
    opacity: 0.75;
}

.text-facebook {
    color: #3b5998;
}

.text-instagram {
    color: #e95950;
}

.footer-copy {
    text-align: center;
    font-size: 12px;
    color: #aaa;
    margin-top: 16px;
    margin-bottom: 0;
}
</style>
